import { api } from "./index";
import type { MeContext } from "@/types/account";

export const apiGetMe = (): Promise<MeContext> =>
  api.get<MeContext>("/api/chat/me").then((r) => r.data);
